import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import * as QueryParams from 'components/Explorer/models/query_params';

// Memoised parse of the current URL search string into the QueryParams shape.
// Re-derives on every push/replace (when `searchParams` identity changes), not
// on every render.
const useQueryParams = () => {
  const [searchParams] = useSearchParams();
  return useMemo(() => QueryParams.parse(searchParams.toString()), [searchParams]);
};

export default useQueryParams;
